import { takeLatest, call, put } from "redux-saga/effects";
import {
  fetchFuelCulpritFailure,
  fetchFuelCulpritSuccess,
} from "../actions/fetchFuelCulpritAction";
import { returnErrors, clearErrors } from "../actions/errorAction";
import * as _api from "../../api";
import * as types from "../types";

function* asyncFetchFuelCulpritSaga(action) {
  try {
    yield put(clearErrors());
    let fuelCulprit = yield call(_api.deviceFuelCulprit, {
      requestDevice: action.payload.requestDevice,
    });
    yield put(fetchFuelCulpritSuccess({ fuelCulprit }));
  } catch (e) {
    yield put(returnErrors({ msg: e.message, status: true }));
    yield put(fetchFuelCulpritFailure({ error: e }));
  }
}
export default function* fetchFuelCulpritSaga() {
  yield takeLatest(types.FETCH_FUEL_CULPRIT_REQUEST, asyncFetchFuelCulpritSaga);
}
